// components/FeaturedSection.js
import { Wallet, ArrowUpDown, Shield } from 'lucide-react';

export default function FeaturedSection() {
  const features = [
    {
      icon: <Wallet className="w-7 h-7" />,
      title: "Multi-Currency Wallet",
      desc: "Store BTC, ETH, USDT, and 50+ assets in one secure wallet."
    },
    {
      icon: <ArrowUpDown className="w-7 h-7" />,
      title: "Instant Swap",
      desc: "Swap any crypto in 3 clicks. No registration, no KYC for small trades."
    },
    {
      icon: <Shield className="w-7 h-7" />,
      title: "Cold Storage",
      desc: "95% of funds in offline wallets. Insured against hacks."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-primary mb-12">
          Powerful Features
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((f, i) => (
            <div key={i} className="text-center">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-primary/10 rounded-full mb-4">
                <div className="text-primary">{f.icon}</div>
              </div>
              <h3 className="text-xl font-bold mb-2">{f.title}</h3>
              <p className="text-gray-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}